import { render, staticRenderFns } from "./messageNotify.vue?vue&type=template&id=3d460ca5&scoped=true&"
import script from "./messageNotify.vue?vue&type=script&lang=js&"
export * from "./messageNotify.vue?vue&type=script&lang=js&"
import style0 from "./messageNotify.vue?vue&type=style&index=0&id=3d460ca5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d460ca5",
  null
  
)

export default component.exports